export const PRACTITIONER_ORDER = 'practitionerOrder';
export const ZOOM_LEVEL = 'zoomLevel';
export const TOKEN = 'token';
export const HIDED_STAFF = 'hidedStaff';
export const CURRENT_CLINIC = 'currentClinic';
export const WSCONNECTION = 'wsConnection';
export const NOT_VISIBLE_START = 'notVisibleStart';
export const CURRENT_CUSTOMER = 'currentCustomer';
export const CURRENT_LEAD_ID = 'currentLeadId';
